"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TabVisibilityMonitor", {
  enumerable: true,
  get: function get() {
    return _TabVisibilityMonitor["default"];
  }
});
var _TabVisibilityMonitor = _interopRequireDefault(require("./TabVisibilityMonitor"));